<template>
  <div>
    <v-btn
      :disabled="dialog"
      :loading="dialog"
      color="#2262c6"
      class="ma-2 white--text"
      @click="getValidations"
    >
      Configuracion

      <v-icon
        right
        dark
      >
        mdi-cog
      </v-icon>

      <template v-slot:loader>
        <span>Configurando</span>
        <v-progress-circular
          indeterminate
          size="16"
          color="primary"
          class="ml-1"
        ></v-progress-circular>
      </template>
    </v-btn>
    <v-dialog
      v-model="dialog"
      persistent
      max-width="1000"
    >
      <v-card
        height="600"
      >
        <v-card-title class="text-h5">
          Configuracion de Validador
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-data-table
              id="data-table-1"
              :headers="columnHeaders"
              :items="tableData"
              :loading="loadingTable"
              loading-text="Obteniendo datos..."
              hide-default-footer
              sort-by="columnNumber"
              fixed-header
              disable-pagination
              height="360px"
            >
              <template v-slot:top>
                <v-toolbar
                  flat
                >
                  <v-dialog
                    v-model="dialogAdd"
                    max-width="500px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        color="primary"
                        dark
                        class="mb-5"
                        v-bind="attrs"
                        v-on="on"
                      >
                        Nueva Columna
                      </v-btn>
                    </template>
                    <v-card>
                      <v-form
                        ref="form-validation-config"
                        lazy-validation
                      >
                        <v-card-title>
                          <span class="text-h5">{{ formTitle }}</span>
                        </v-card-title>

                        <v-card-text>
                          <v-container>
                            <v-row class="dialog-validation-config">
                              <v-col
                                cols="12"
                                sm="12"
                                md="12"
                              >
                                <v-text-field
                                  outlined
                                  v-model="editedItem.columnName"
                                  label="Nombre"
                                  hide-details="auto"
                                  required
                                  :rules="rules.nameRules"
                                ></v-text-field>
                              </v-col>
                              <v-col
                                cols="12"
                                sm="4"
                                md="4"
                              >
                                <v-text-field
                                  outlined
                                  v-model="editedItem.columnNumber"
                                  label="Orden"
                                  hide-details="auto"
                                  required
                                  :rules="rules.orderRules"
                                ></v-text-field>
                              </v-col>
                              <v-col
                                cols="12"
                                sm="4"
                                md="4"
                              >
                                <v-autocomplete
                                  v-model="editedItem.columnType"
                                  :items="columnTypes"
                                  clearable
                                  outlined
                                  label="Tipo"
                                  hide-details="auto"
                                  :rules="rules.typeRules"
                                  required
                                ></v-autocomplete>
                              </v-col>
                              <v-col
                                cols="12"
                                sm="4"
                                md="4"
                              >
                                <v-switch
                                  v-model="editedItem.optional"
                                  :true-value="1"
                                  :false-value="0"
                                  label="Opcional"
                                ></v-switch>
                              </v-col>
                              <v-col
                                cols="12"
                                sm="12"
                                md="12"
                              >
                                <v-switch
                                  v-model="editedItem.customValidation"
                                  :true-value="1"
                                  :false-value="0"
                                  label="Custom Validation"
                                ></v-switch>
                              </v-col>
                              <v-col
                                v-if="editedItem.customValidation"
                                cols="12"
                                sm="12"
                                md="12"
                              >
                                <v-text-field
                                  v-model="editedItem.customValidationQuery"
                                  label="Custom Query"
                                  outlined
                                  hide-details="auto"
                                  :required="editedItem.customValidation"
                                  :rules="rules.customQueryRules"
                                ></v-text-field>
                              </v-col>
                              <v-col
                                v-if="editedItem.customValidation"
                                cols="12"
                                sm="12"
                                md="12"
                              >
                                <v-text-field
                                  v-model="editedItem.errorMessage"
                                  label="Custom Error"
                                  outlined
                                  hide-details="auto"
                                  :required="editedItem.customValidation"
                                  :rules="rules.customErrorRules"
                                ></v-text-field>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-card-text>

                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            color="blue darken-1"
                            text
                            @click="close"
                          >
                            Cancel
                          </v-btn>
                          <v-btn
                            color="blue darken-1"
                            text
                            @click="save"
                          >
                            Save
                          </v-btn>
                        </v-card-actions>
                      </v-form>
                    </v-card>
                  </v-dialog>
                  <v-dialog v-model="dialogDelete" max-width="500px">
                    <v-card>
                      <v-card-title class="text-h5">Está seguro de que quiere eliminar la columna?</v-card-title>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                        <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                        <v-spacer></v-spacer>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-toolbar>
              </template>
              <template v-slot:item.optional="{ item }">
                <v-checkbox
                  v-model="item.optional"
                  disabled
                ></v-checkbox>
              </template>
              <template v-slot:item.customValidation="{ item }">
                <v-checkbox
                  v-model="item.customValidation"
                  disabled
                ></v-checkbox>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-icon
                  small
                  class="mr-2"
                  @click="editItem(item)"
                >
                  mdi-pencil
                </v-icon>
                <v-icon
                  small
                  @click="deleteItem(item)"
                >
                  mdi-delete
                </v-icon>
              </template>
              <template v-slot:no-data>
                <v-btn
                  color="primary"
                  @click="getValidations"
                >
                  Reset
                </v-btn>
              </template>
            </v-data-table>
          </v-container>
        </v-card-text> 
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red darken-1"
            @click="closeDialog"
            :disabled="loadingSave"
            outlined
          >
            Cerrar
          </v-btn>
          <v-btn
            color="blue darken-1"
            :disabled="loadingSave"
            :loading="loadingSave"
            outlined
            @click="sendData"
            :style="{'width' : loadingSave ? '160px' : ''}"
          >
            Guardar

            <template v-slot:loader>
              <span>Guardando</span>
              <v-progress-circular
                indeterminate
                size="16"
                color="primary"
                class="ml-1"
              ></v-progress-circular>
            </template>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import uris from '../../../utils/uris'
import axios from '../../../utils/axiosWrapperAutoservicio'
import userStorage from '../../../storage/userStorage'
import eventBus from '../../../utils/eventBus'

export default {
  name: 'validation-header',
  data () {
    const user = userStorage.getUserInfo()
    return {
      userType: user.userType,
      isAdmin: user.userType === 'ADMIN',
      loadingTable: false,
      loadingSave: false,
      dialog: false,
      dialogAdd: false,
      dialogDelete: false,
      columnTypes: ['string', 'int', 'float', 'date'],
      rules: {
        nameRules: [
          v => !!v || 'Nombre es obligatorio'
        ],
        customQueryRules: [
          v => !!v || 'Custom query es obligatorio'
        ],
        customErrorRules: [
          v => !!v || 'Custom error es obligatorio'
        ],
        typeRules: [
          v => !!v || 'Tipo es obligatorio'
        ],
        orderRules: [
          v => /^\d/.test(v) || 'Orden es obligatorio',
          v => Number(v) > 0 || 'Orden no puede ser 0',
          v => this.validacionOrder(v) || 'Orden ya existe'
        ]
      },
      columnHeaders: [
        {text: 'Orden', value: 'columnNumber'},
        {text: 'Campo', value: 'columnName'},
        {text: 'Tipo', value: 'columnType'},
        {text: 'Opcional', value: 'optional'},
        {text: 'Custom Validacion', value: 'customValidation'},
        {text: 'Custom Query', value: 'customValidationQuery'},
        {text: 'Custom Error', value: 'errorMessage'},
        {text: 'Actions', value: 'actions', sortable: false}
      ],
      editedIndex: -1,
      editedItem: {
        optional: 0,
        columnName: '',
        columnType: '',
        columnNumber: 0,
        errorMessage: '',
        customValidation: 0,
        customValidationQuery: '',
        validationStructureId: 0
      },
      itemBeforeEdited: {},
      defaultItem: {
        optional: 0,
        columnName: '',
        columnType: '',
        columnNumber: 0,
        errorMessage: '',
        customValidation: 0,
        customValidationQuery: '',
        validationStructureId: 0
      },
      tableData: []
    }
  },
  props: {
    processID: {
      type: Number,
      default () {
        return 0
      }
    }
  },
  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Nueva Columna' : 'Editar Columna'
    }
  },
  methods: {
    goToTop () {
      this.$vuetify.goTo(
        '#data-table-1',
        {
          offset: -50,
          container: '#data-table-1 .v-data-table__wrapper'
        }
      )
    },
    goToNewRow () {
      const tableWrapper = document.querySelector('#data-table-1 .v-data-table__wrapper')
      this.$vuetify.goTo(
        tableWrapper.scrollHeight,
        {
          container: '#data-table-1 .v-data-table__wrapper'
        }
      )
    },
    closeDialog () {
      this.goToTop()
      this.dialog = false
    },
    sendData () {
      // console.log(this.tableData)
      this.loadingSave = true
      axios.post(uris.URL_AUTOSERVICIO_UPSERT_VALIDATIONS, {
        data: this.tableData,
        processID: this.processID
      })
        .then((response) => {
          eventBus.$emit('open-custom-snack-bar', {message: 'Data Ingresada', itsOk: true})
          this.goToNewRow()
        })
        .catch((err) => {
          console.warn('No se ha podido obtener data de la configuración', err)
        })
        .finally(() => {
          this.loadingSave = false
        })
    },
    validacionOrder (v) {
      let valueNumber = Number(v)
      let arrayOrder = this.tableData.map(d => d.columnNumber)
      if (this.editedIndex !== -1) {
        let valueBeforeEdited = Number(this.itemBeforeEdited.columnNumber)
        let indexValue = arrayOrder.indexOf(valueBeforeEdited)
        if (indexValue !== -1) {
          arrayOrder.splice(indexValue, 1)
        }
      }
      return !arrayOrder.includes(valueNumber)
    },
    getValidations () {
      this.dialog = true
      this.loadingTable = true
      axios.post(uris.URL_AUTOSERVICIO_GET_VALIDATIONS, {
        processID: this.processID
      })
        .then((response) => {
          this.tableData = response.data
        })
        .catch((err) => {
          console.warn('No se ha podido obtener data de la configuración', err)
        })
        .finally(() => {
          this.loadingTable = false
        })
    },
    editItem (item) {
      this.editedIndex = this.tableData.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.itemBeforeEdited = Object.assign({}, item)
      this.dialogAdd = true
    },

    deleteItem (item) {
      this.editedIndex = this.tableData.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialogDelete = true
    },

    deleteItemConfirm () {
      this.tableData.splice(this.editedIndex, 1)
      this.closeDelete()
    },

    close () {
      this.$refs['form-validation-config'].resetValidation()
      this.dialogAdd = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },

    closeDelete () {
      this.dialogDelete = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },

    save () {
      if (this.$refs['form-validation-config'].validate()) {
        if (this.editedIndex > -1) {
          Object.assign(this.tableData[this.editedIndex], this.editedItem)
        } else {
          this.tableData.push(this.editedItem)
          this.goToNewRow()
        }
        this.close()
      }
    }
  }
}
</script>

<style>
/* Correción para el texto en outline que se va mucho a la izquierda */
.dialog-validation-config .v-label.theme--light.error--text {
left: 0 !important;
}
.dialog-validation-config .v-label.v-label--active.theme--light {
left: 0 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/autoservicios/validation/validation-config.vue